//Please try not to change the variable names.
//If you do, you must update Octopus Deploy so it replaces the variable name properly.
//todo: change all of thest to match our product
export default {
    enterpriseApiUrl: "#{ApiUrl}",
    authApiUrl: "#{AuthApiUrl}",
    authUiUrl: "#{AuthUiUrl}",
    cdnUrl: "#{CDNUrl}",
    cdnUrlGifs: "#{CDNUrlGifs}",
    cdnUrlIcons: "#{CDNUrlIcons}",
    cdnUrlIllustrations: "#{CDNUrlIllustrations}",
    cdnUrlLoadingAnimations: "#{CDNUrlLoadingAnimations}",
    cdnUrlLogos: "#{CDNUrlLogos}",
    appInsightInstrumentationKey: "#{AppInsightInstrumentationKey}",
    pendoInstallCode: "#{PendoInstallCode}",
    supportInfo: {
        email: "#{NcontractsSupportEmail}",
        phone: "#{NcontractsSupportPhone}"
    },
    hotjarId: "#{hotjarId}",
    productTrackingUrl: '#{productTrackingUrl}',
    clientId: "973f8ca3-79d7-46a8-bfd8-3f45bd06d4f5",
};
